import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { PreviewLayout } from "core/layouts";
import { ApplicationEmptyState, GlobalSignalRListener, BaasicButton, BasicCheckbox } from "core/components";
import { FacilityOrderNewFlowStatusBar } from "application/facility-order-new-flow-us-intake/components";
import { toDate } from "core/utils";
import { observer } from "mobx-react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Button } from "@progress/kendo-react-buttons";

const FacilityOrderNewFlowBillingPreviewTemplate = function ({ facilityOrderNewFlowBillingPreviewViewStore, t }) {
    const {
        rootStore,
        facilityOrderId,
        facilityOrder,
        loaderStore,
        facilityOrderTemplatesGroupByPatient,
        fetchingTemplates,
        showPatientTemplates,
        showPatientList,
        currentIndex,
        isStatusBarVisible,
        changeStatusBarVisibility,
        facilityOrderStatus,
        sendOrderFacilityOrderStatus,
        showCompleteButton,
        completeImport,
        signalRAction,
        pickTicketHeaderStatus,
        startBillingFlow,
        isBillingDisabled,
        orderHistory,
        goToFacilityPreview,
        goToFacilityCalendar,
        downloadFacilityOrder,
        isInventoryStepAllowed,
        downloadDeliveryTicket
    } = facilityOrderNewFlowBillingPreviewViewStore;

    return (
        <PreviewLayout className="container container--new-flow" store={facilityOrderNewFlowBillingPreviewViewStore} emptyRenderer={<ApplicationEmptyState />} layoutFooterVisible={false} loading={loaderStore.loading || fetchingTemplates}>
            <GlobalSignalRListener groupId={facilityOrderId} rootStore={rootStore} action={signalRAction} />
            {((pickTicketHeaderStatus && pickTicketHeaderStatus != "new") || (facilityOrder && facilityOrder.sendOrder)) &&
                <div className='purches-notification'>
                    <div className='message__bar purches-notification-row'>
                        <span>{pickTicketHeaderStatus === "in-progress" ? "Purchasing is in progress. Don't make changes to the facility order." : pickTicketHeaderStatus === "completed" ? "Purchasing is complete. Don't make changes to the facility order." : "Billing is in Progress, any changes made must be reported to the biller."}</span>
                    </div>
                </div>
            }
            <FacilityOrderNewFlowStatusBar facilityOrder={facilityOrder} title={facilityOrder && `${facilityOrder.facility.name} - DOS ${toDate(facilityOrder.dateOfService)}`} isOpen={isStatusBarVisible} changeStatusBarVisibility={() => changeStatusBarVisibility()} isInventoryStepAllowed={isInventoryStepAllowed}>
                <div className="content__header__actions">
                <ReactTooltip positionStrategy="fixed" id="historyTooltip" place="bottom" />
                    <Button className="btn btn--base btn--light u-mar--right--tny" icon="u-icon u-icon--med-lrg u-icon--us-history" onClick={() => orderHistory()} data-tooltip-content="Facility Order History" data-tooltip-id="historyTooltip" />

                    <ReactTooltip positionStrategy="fixed" id="facilityPreviewTooltip" place="bottom" />
                    <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Facility Preview" data-tooltip-id="facilityPreviewTooltip" onClick={() => goToFacilityPreview()}><i className="u-icon u-icon--sml u-icon--preview--dark"></i></a>
                    
                    <ReactTooltip positionStrategy="fixed" id="orderingTooltip" place="bottom" />
                    <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Ordering Calendar" data-tooltip-id="orderingTooltip" onClick={() => goToFacilityCalendar()}><i className="u-icon u-icon--sml u-icon--schedules"></i></a>
                    
                    <ReactTooltip positionStrategy="fixed" id="reportTooltip" place="bottom" />
                    <a className="btn btn--base btn--light" target='_blank' data-tooltip-content="FO Report Download" data-tooltip-id="reportTooltip" onClick={() => downloadFacilityOrder()}><i className="u-icon u-icon--sml u-icon--download--brand"></i></a>
                </div>
            </FacilityOrderNewFlowStatusBar>
            <div className="u-mar--top--lrg">
                {!(sendOrderFacilityOrderStatus && sendOrderFacilityOrderStatus.completedOn) ?
                    <p>Billing cannot be started because the import has not yet started.</p> :
                    <React.Fragment>
                        {!facilityOrderStatus &&
                            <div className="u-flex--space-between u-mar--bottom--sml u-mar--top--med">
                                <div className="card card--outlined--featured card--sml card--flex ">
                                    <div className="u-flex--space-between">
                                        <h4 className="type--wgt--medium type--narrow">{t('FACILITY_ORDER_TEMPLATE_NEW_FLOW_IMPORT.START_BILLING')}</h4>
                                        <div className="u-flex--default">
                                            <BaasicButton
                                                className={"btn btn--base btn--ghost u-mar--right--sml"}
                                                label={'Delivery Ticket'}
                                                icon="u-icon u-icon--sml u-icon--download-btn"
                                                onClick={() => downloadDeliveryTicket()}>
                                            </BaasicButton>
                                            <BaasicButton className="btn btn--base btn--primary u-align--h--right" icon="u-icon u-icon--xsml u-icon--play" label={t('FACILITY_ORDER_NEW_FLOW_INVENTORY.PREVIEW.START_LABEL')} onClick={() => startBillingFlow()} disabled={isBillingDisabled} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        { facilityOrderStatus &&
                            <div className="type--right u-mar--bottom--med">
                                <BaasicButton
                                    className={"btn btn--base btn--ghost"}
                                    label={'Delivery Ticket'}
                                    icon="u-icon u-icon--sml u-icon--download-btn"
                                    onClick={() => downloadDeliveryTicket()}>
                                </BaasicButton>
                            </div>
                        }
                        {showPatientList && facilityOrderTemplatesGroupByPatient && facilityOrderTemplatesGroupByPatient.length > 0 ?
                            facilityOrderTemplatesGroupByPatient.map((group, index) => {
                                return (
                                    <div key={group.id} className='card--import' onClick={() => facilityOrderStatus ? showPatientTemplates(true, index) : {}}>
                                        <span className="type--med">
                                            {group.patient.lastName && `${group.patient.lastName}`}
                                            {group.patient.firstName && ', '}
                                            {group.patient.firstName && `${group.patient.firstName}`}
                                        </span>
                                        <div className={`card--import__status ${group.statusStyle}`}>
                                            <div className='card--import__status__iconwrap'>
                                                <i className="card--import__status__icon"></i>
                                            </div>
                                            {group.importStatusName}
                                        </div>
                                    </div>
                                );
                            })
                            :
                            !showPatientList && facilityOrderTemplatesGroupByPatient && facilityOrderTemplatesGroupByPatient.length > 0 ?
                                <PatientFacilityOrderTemplates facilityOrderTemplates={facilityOrderTemplatesGroupByPatient[currentIndex].item} patient={facilityOrderTemplatesGroupByPatient[currentIndex].patient} facilityOrderPatient={facilityOrderTemplatesGroupByPatient[currentIndex].facilityOrderPatient} facilityOrderNewFlowBillingPreviewViewStore={facilityOrderNewFlowBillingPreviewViewStore}></PatientFacilityOrderTemplates>
                                :
                                <React.Fragment></React.Fragment>
                        }
                    </React.Fragment>
                }
                {showCompleteButton && (currentIndex == null || currentIndex == undefined) &&
                    <div className="patient__floating">
                        <div className="u-flex--default u-flex--gap--2">
                            <i className="u-icon u-icon--med u-icon--negative--success"></i>
                            <div>You reviewed all patients</div>
                        </div>
                        <button className="btn btn--base btn--negative" onClick={async () => await completeImport()}>Complete Import</button>
                    </div>}
            </div>
        </PreviewLayout>
    );
};

const PatientFacilityOrderTemplates = observer(({ facilityOrderTemplates, patient, facilityOrderPatient, facilityOrderNewFlowBillingPreviewViewStore }) => {
    const {
        goToBT,
        showPatientTemplates,
        currentIndex,
        facilityOrderTemplatesGroupByPatient,
        completeImport,
        showCompleteButton,
        completePatientValidation
    } = facilityOrderNewFlowBillingPreviewViewStore;
    return (
        <div>
            <div className="u-flex--space-between">
                <div className="patient__header">
                    {patient && <h2>
                        {patient.lastName && `${patient.lastName}`}
                        {patient.firstName && ', '}
                        {patient.firstName && `${patient.firstName}`}
                    </h2>}
                    <div>
                        <i className={`u-icon u-icon--med-lrg u-mar--right--tny u-icon--insurance-external-link`} />
                        <Button className={`btn btn--link btn--link--underline type--wgt--regular type--sml`} onClick={() => goToBT(patient.patientKey)}>{patient.patientId}</Button>
                    </div>
                </div>
                <div className="u-flex u-flex--gap--4 ">
                    <ReactTooltip positionStrategy="fixed" id={"registerTip" + patient.id} place="top" />
                    <Button className="btn btn--icon btn--icon--sml-med btn--icon--trans" icon="u-icon u-icon--med u-icon--back-to-list" onClick={() => showPatientTemplates(true)} data-tooltip-id={"registerTip" + patient.id} data-tooltip-content="Back to all patients"></Button>
                    <div className="u-separator--default"></div>
                    <Button className="btn btn--icon--sml-med btn--icon btn--icon--white" icon="u-icon u-icon--xxsml u-icon--arrow-left--enabled" onClick={() => showPatientTemplates(false, currentIndex - 1)} disabled={currentIndex == 0}></Button>
                    <Button className="btn btn--icon--sml-med btn--icon btn--icon--white" icon="u-icon u-icon--xxsml u-icon--arrow-right--enabled" onClick={() => showPatientTemplates(false, currentIndex + 1)} disabled={currentIndex == facilityOrderTemplatesGroupByPatient.length - 1}></Button>
                    {showCompleteButton && <Button className="btn btn--base btn--primary" onClick={async () => await completeImport()}>Complete import</Button>}
                </div>
            </div>
            <div>
                <div className="card--tertiary__data u-mar--bottom--lrg">
                    <div className="type--color--primary type--wgt--semibold">Insurance:</div>
                    <div>
                        <div className="card--tertiary__data__item">
                            <div>Primary:</div>
                            <div className="type--color--primary type--wgt--semibold">{patient.primaryInsurance}</div>
                            {patient.primaryPolicyNo &&
                                <div>{patient.primaryPolicyNo}</div>
                            }
                        </div>
                    </div>
                    <div>
                        <div className="card--tertiary__data__item">
                            <div>Secondary:</div>
                            <div className="type--color--primary type--wgt--semibold">{patient.secondaryInsurance}</div>
                            {patient.secondaryPolicyNo &&
                                <div>{patient.secondaryPolicyNo}</div>
                            }
                        </div>
                    </div>
                    <div>
                        <div className="card--tertiary__data__item">
                            <div>Tertiary:</div>
                            <div className="type--color--primary type--wgt--semibold">{patient.tertiaryInsurance}</div>
                            {patient.tertiaryPolicyNo &&
                                <div>{patient.tertiaryPolicyNo}</div>
                            }
                        </div>
                    </div>
                </div>
                {facilityOrderPatient.facilityOrderPatientValidations.map((item) => {
                    return (
                        <div key={"validation-" + item.id} className={`c-message--import ${item.isResolved ? "is-grey" : "is-yellow"} u-mar--bottom--sml`}>
                            <div className="u-flex--default u-flex--gap--2">
                                <i className="u-icon u-icon--med c-message--import__icon"></i>
                                <div>{item.notes}</div>
                            </div>
                            <div className="u-flex--default u-flex--gap--2">
                                <div className="c-message--import__label">Complete</div>
                                <BasicCheckbox id={item.id} checked={item.isResolved} onChange={async () => await completePatientValidation(facilityOrderPatient, currentIndex, item.id)} disabled={item.isResolved} />
                            </div>
                        </div>
                    );
                })}
            </div>
            {facilityOrderTemplates.map(template => {
                return (
                    <FacilityOrderTemplate
                        key={template.id}
                        facilityOrderTemplate={template}
                        facilityOrderPatient={facilityOrderPatient}
                        facilityOrderNewFlowBillingPreviewViewStore={facilityOrderNewFlowBillingPreviewViewStore} />);
            })}
        </div>
    );
});

const FacilityOrderTemplate = observer(({ facilityOrderTemplate, facilityOrderPatient, facilityOrderNewFlowBillingPreviewViewStore }) => {
    const {
        openTemplateInBT,
        openSalesOrderInBT,
        getTemplateImportStatus,
        getDiagnosisCodes,
        getTemplateStatusStyle,
        reviewTemplate,
        currentIndex,
        completeTemplateValidation,
        insertImportActionId
    } = facilityOrderNewFlowBillingPreviewViewStore;
    const isBillToInsurance = (facilityOrderTemplate.clinicalStatus && facilityOrderTemplate.clinicalStatus.name === "Covered") || (facilityOrderTemplate.clinicalStatus && facilityOrderTemplate.clinicalStatus.name === "Prior Auth Obtained");

    return (
        <div className={`card--quaternary u-mar--bottom--sml`}>

            <div className="card--quaternary__header">
                <div className="u-flex--default u-flex--gap--2">
                    <div className="type--color--secondary">Template ID: <a className="type--underline type--wgt--regular" onClick={() => { openTemplateInBT(facilityOrderTemplate.templateId) }}>{facilityOrderTemplate.templateId}</a></div> <span className="type--ciolor--secondary">•</span>
                    <div className="type--color--secondary">Sales Order ID: <Button className={`btn btn--link btn--link--underline`} onClick={() => { openSalesOrderInBT(facilityOrderTemplate.salesOrderId) }}>{facilityOrderTemplate.salesOrderId}</Button></div>
                </div>
                <div className="u-flex--default u-flex--gap--2">
                    <div className="type--color--primary type--wgt--medium type--base">{facilityOrderTemplate.subCategory.name}</div>
                    <div className={`card--import__status is-free ${getTemplateStatusStyle(facilityOrderTemplate, facilityOrderPatient)}`}>
                        <div className='card--import__status__iconwrap'>
                            <i className="card--import__status__icon"></i>
                        </div>
                        {getTemplateImportStatus([facilityOrderTemplate], facilityOrderPatient).toUpperCase()}
                    </div>
                </div>
            </div>
            <div className="card--quaternary__body">
                <div className="card--quaternary__subheader">
                    <div className="u-flex--default u-flex--align-start u-flex--gap--4 type--color--secondary">
                        <div className="w--300--min">
                            <div className="u-mar--bottom--tny">Billed to insurance: <span className={`u-icon u-icon--med ${isBillToInsurance ? 'u-icon--check--green' : 'u-icon--close--red'}`}></span></div>
                            <div>Ordering doctor: <span className="type--color--text">{facilityOrderTemplate.orderingDoctor && facilityOrderTemplate.orderingDoctor.name}</span></div>
                        </div>
                        <div className="w--300--min">
                            <div className="u-mar--bottom--tny">Reference: <span className="type--color--text">{facilityOrderTemplate.newReference}</span></div>
                            <div>Diagnosis codes: <span className="type--color--text">{getDiagnosisCodes(facilityOrderTemplate)}</span></div>
                        </div>
                        {facilityOrderTemplate.inactiveReasonId !== 0 && facilityOrderTemplate.inactiveReasonId !== null && (
                            <div className="w--300--min">
                                Inactive reason:&nbsp;
                                <span className="type--color--text is-red" style={{ color: '#d13737' }}>
                                    {facilityOrderTemplate.inactiveReason === "DoNotSupply" ? "Do Not Supply" : facilityOrderTemplate.inactiveReason}
                                </span>
                            </div>
                        )}
                    </div>
                </div>

                {facilityOrderTemplate.importDetailStatus.abrv === "failed" &&
                    <div className={`c-message--import ${facilityOrderTemplate.isImportReviewed ? "is-grey" : "is-red"} u-mar--bottom--sml`}>
                        <div className="u-flex--default u-flex--gap--2">
                            <i className="u-icon u-icon--med c-message--import__icon"></i>
                            <div>{facilityOrderTemplate.customErrorMessage && facilityOrderTemplate.customErrorMessage != "" ? facilityOrderTemplate.customErrorMessage : facilityOrderTemplate.errorMessage && facilityOrderTemplate.errorMessage.toLowerCase().includes("the underlying connection was closed") ? "Import failed due to a connection issue." : "Import Failed"}</div>
                        </div>

                        <div className="u-flex--default u-flex--gap--2">
                            <div className="c-message--import__label">Updated Manually</div>
                            <BasicCheckbox id={facilityOrderTemplate.id} checked={facilityOrderTemplate.isImportReviewed} onChange={async () => await reviewTemplate(facilityOrderTemplate.id, currentIndex)} disabled={facilityOrderTemplate.isImportReviewed} />
                        </div>
                    </div>
                }

                {facilityOrderTemplate.facilityOrderTemplateValidations.map((item) => {
                    return (
                        <div key={"validation-" + item.id} className={`c-message--import ${item.isResolved ? "is-grey" : "is-yellow"} u-mar--bottom--med`}>
                            <div className="u-flex--default u-flex--gap--2">
                                <i className="u-icon u-icon--med c-message--import__icon"></i>
                                <div>{item.validation.name}</div>
                            </div>
                            <div className="u-flex--default u-flex--gap--2">
                                <div className="c-message--import__label">Complete</div>
                                <BasicCheckbox id={item.id} checked={item.isResolved} onChange={async () => await completeTemplateValidation(facilityOrderTemplate.id, currentIndex, item.id)} disabled={item.isResolved} />
                            </div>
                        </div>
                    );
                })}

                <div className="table--preview__wrapper">
                    <table className="table--preview w--100">
                        <colgroup>
                            <col width={150} />
                            <col width={400} />
                            <col width={120} />
                            <col width={120} />
                            <col width={120} />
                            <col width={120} />
                            <col />

                        </colgroup>
                        <thead>
                            <tr>
                                <th>ITEM ID</th>
                                <th>ITEM NAME</th>
                                <th>TEMP QTY</th>
                                <th>TEMP BQTY</th>
                                <th>SO QTY</th>
                                <th>SO BQTY</th>
                                <th colSpan="2">
                                    <div className="u-flex--default u-flex--space-between">
                                        <label>ITEM NOTE</label>
                                        <div className="u-flex--default u-flex--space-between u-flex--gap--1">
                                            {facilityOrderTemplate.newFlowStatus && facilityOrderTemplate.newFlowStatus.abrv === "no-change" && <i className="u-icon u-icon--xsml u-icon--ticked"></i>}
                                            {facilityOrderTemplate.newFlowStatus && facilityOrderTemplate.newFlowStatus.abrv === "change" && <i className="u-icon u-icon--xsml u-icon--dangered"></i>}
                                            {facilityOrderTemplate.newFlowStatus && facilityOrderTemplate.newFlowStatus.abrv === "discharge" && <i className="u-icon u-icon--xsml u-icon--closed"></i>}
                                            {facilityOrderTemplate.newFlowStatus && facilityOrderTemplate.newFlowStatus.abrv === "new-order" && <i className="u-icon u-icon--xsml u-icon--is-new"></i>}
                                            <label>{facilityOrderTemplate.newFlowStatus && facilityOrderTemplate.newFlowStatus.name}</label>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {facilityOrderTemplate.facilityOrderTemplateItems.map((item) => {
                                return (
                                    <tr key={item.id} className={(facilityOrderTemplate.importActionId != insertImportActionId && item.importActionId === insertImportActionId) ? "new-row" : (item.importAction && item.importAction.abrv === "delete" ? "deleted-row" : "")}>
                                        <td>
                                            {item.product && item.product.itemId}
                                        </td>
                                        <td>
                                            {item.product && item.product.description}
                                        </td>
                                        <td className="table-col-input text-align-left">
                                            <ReactTooltip positionStrategy="fixed" id={"registerTipItemChanged" + item.id} place="top" />
                                            {(item.facilityOrderTemplateItemInitial && item.templateQuantity != item.facilityOrderTemplateItemInitial.templateQuantity) && <div className="input--change--text" data-tooltip-id={"registerTipItemChanged" + item.id} data-tooltip-content={"Previous: " + (item.facilityOrderTemplateItemInitial && item.facilityOrderTemplateItemInitial.templateQuantity ? item.facilityOrderTemplateItemInitial.templateQuantity : "blank")}></div>}
                                            {item.product &&
                                                <input
                                                    className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                                    value={item.templateQuantity}
                                                    type="number"
                                                    style={{ pointerEvents: "none" }}
                                                />
                                            }
                                        </td>
                                        <td className="table-col-input text-align-left">
                                            <ReactTooltip positionStrategy="fixed" id={"registerTipItemChanged" + item.id} place="top" />
                                            {(item.facilityOrderTemplateItemInitial && item.templateBillingQuantity != item.facilityOrderTemplateItemInitial.templateBillingQuantity) && <div className="input--change--text" data-tooltip-id={"registerTipItemChanged" + item.id} data-tooltip-content={"Previous: " + (item.facilityOrderTemplateItemInitial && item.facilityOrderTemplateItemInitial.templateBillingQuantity ? item.facilityOrderTemplateItemInitial.templateBillingQuantity : "blank")}></div>}
                                            {item.product &&
                                                <input
                                                    className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                                    value={item.templateBillingQuantity}
                                                    type="number"
                                                    style={{ pointerEvents: "none" }}
                                                />
                                            }
                                        </td>
                                        <td className="table-col-input text-align-left">
                                            <ReactTooltip positionStrategy="fixed" id={"registerTipItemChanged" + item.id} place="top" />
                                            {(item.facilityOrderTemplateItemInitial && item.orderQuantity != item.facilityOrderTemplateItemInitial.orderQuantity) && <div className="input--change--text" data-tooltip-id={"registerTipItemChanged" + item.id} data-tooltip-content={"Previous: " + (item.facilityOrderTemplateItemInitial && item.facilityOrderTemplateItemInitial.orderQuantity ? item.facilityOrderTemplateItemInitial.orderQuantity : "blank")}></div>}
                                            {item.product &&
                                                <input
                                                    className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                                    value={item.orderQuantity}
                                                    type="number"
                                                    style={{ pointerEvents: "none" }}
                                                />
                                            }
                                        </td>
                                        <td className="table-col-input text-align-left">
                                            <ReactTooltip positionStrategy="fixed" id={"registerTipItemChanged" + item.id} place="top" />
                                            {(item.facilityOrderTemplateItemInitial && item.billingQuantity != item.facilityOrderTemplateItemInitial.billingQuantity) && <div className="input--change--text" data-tooltip-id={"registerTipItemChanged" + item.id} data-tooltip-content={"Previous: " + (item.facilityOrderTemplateItemInitial && item.facilityOrderTemplateItemInitial.billingQuantity ? item.facilityOrderTemplateItemInitial.billingQuantity : "blank")}></div>}
                                            {item.product &&
                                                <input
                                                    className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                                    value={item.billingQuantity}
                                                    type="number"
                                                    style={{ pointerEvents: "none" }}
                                                />
                                            }
                                        </td>
                                        <td colSpan="2" className="table-col-input">
                                            <ReactTooltip positionStrategy="fixed" id={"registerTipItemChanged" + item.id} place="top" />
                                            {(item.facilityOrderTemplateItemInitial && item.note != item.facilityOrderTemplateItemInitial.note) && <div className="input--change--text" data-tooltip-id={"registerTipItemChanged" + item.id} data-tooltip-content={"Previous: " + (item.facilityOrderTemplateItemInitial && item.facilityOrderTemplateItemInitial.note ? item.facilityOrderTemplateItemInitial.note : "blank")}></div>}
                                            <input
                                                className="input--table input--inherit-color no-arrows input--text-align--left w--100 u-mar--left--tny"
                                                value={item.note}
                                                style={{ pointerEvents: "none" }}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
});

PatientFacilityOrderTemplates.propTypes = {
    facilityOrderTemplate: PropTypes.object.isRequired,
    facilityOrderPatient: PropTypes.object.isRequired,
    patient: PropTypes.object.isRequired,
};

FacilityOrderTemplate.propTypes = {
    facilityOrderTemplate: PropTypes.object.isRequired,
};

FacilityOrderNewFlowBillingPreviewTemplate.propTypes = {
    facilityOrderNewFlowBillingPreviewViewStore: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderNewFlowBillingPreviewTemplate);